






















import { Component, Vue } from 'vue-property-decorator';
import AuthManager from '@/auth';

@Component
export default class UserNotFound extends Vue {
    public SignOut() {
        AuthManager.Instance.signOut();
    }
}
